import { render, staticRenderFns } from "./radio-quarternary.vue?vue&type=template&id=13a6da6a&scoped=true"
import script from "./radio-quarternary.vue?vue&type=script&lang=js"
export * from "./radio-quarternary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a6da6a",
  null
  
)

export default component.exports